import { render, staticRenderFns } from "./task-record.vue?vue&type=template&id=7c0f9bd7"
import script from "./task-record.vue?vue&type=script&lang=js"
export * from "./task-record.vue?vue&type=script&lang=js"
import style0 from "./task-record.vue?vue&type=style&index=0&id=7c0f9bd7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports